const MAX_EDGE = 1280
const TARGET_CHARS = 700_000

function canvasToJpeg(canvas: HTMLCanvasElement, quality: number) {
  return canvas.toDataURL('image/jpeg', quality)
}

export async function compressImage(file: File) {
  if (!file.type.startsWith('image/') && file.type !== '') {
    throw new Error('That file is not a photo. Try a JPG or PNG.')
  }

  let bitmap: ImageBitmap
  try {
    bitmap = await createImageBitmap(file)
  } catch {
    throw new Error(
      'Could not read that photo. iPhone Live/HEIC shots sometimes fail — try JPG or take a new picture.',
    )
  }

  const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height))
  const width = Math.max(1, Math.round(bitmap.width * scale))
  const height = Math.max(1, Math.round(bitmap.height * scale))
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) {
    bitmap.close()
    throw new Error('Could not prepare that photo. Try another one.')
  }
  ctx.drawImage(bitmap, 0, 0, width, height)
  bitmap.close()

  let quality = 0.82
  let dataUrl = canvasToJpeg(canvas, quality)
  while (dataUrl.length > TARGET_CHARS && quality > 0.5) {
    quality -= 0.12
    dataUrl = canvasToJpeg(canvas, quality)
  }

  if (dataUrl.length > TARGET_CHARS * 1.6) {
    throw new Error('That photo is still too big. Crop closer to the leaves and try again.')
  }

  return { dataUrl, width, height }
}
